import { Auth } from "aws-amplify";
import { useCallback, useState } from "react";

export const useFetch = (url: string) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const get = useCallback(async <T>(): Promise<T | undefined> => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    setLoading(true);
    try {
      const result = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => response.json());
      return result;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [url]);

  return { get, isLoading };
};
